import { DeleteAndMoveProductions } from "components/modals/DeleteMoveItems";
import GeneralOptionsPanel from "components/optionspanel/GeneralOptionsPanel";
import SectionPanel from "components/panels/SectionPanel/SectionPanel";
import TwoColumnLayout from "layout/TwoColumnLayout";
import ShowsPanelForProduction from "Production/components/ShowsPanelForProduction";
import React from "react";
import { useLoaderData } from "react-router";
import { isPanelVisible } from "utilities/panelUtils";
import ProductionActivityPanel from "./activity/App";
import ConfirmCopyProductionModal from "./ConfirmCopyProductionModal";
import { ProductionDetailSection } from "./ProductionDetailSection";

const ProductionDetailApp = () => {
  const viewModel = useLoaderData<server.viewmodel.ProductionDetailFrontModel>();
  const [displayDeleteModal, setDisplayDeleteModal] = React.useState(false);
  const [displayCopyModal, setDisplayCopyModal] = React.useState(false);
  const [showInProductionCount, setShowInProductionCount] = React.useState<number>(0);

  const { production } = viewModel;

  return <TwoColumnLayout>
    <TwoColumnLayout.LeftColumn>
      <SectionPanel.Section>
        <ProductionDetailSection
          production={production}
          ffCategories={viewModel.freeFieldCategories}
          ffPermissions={viewModel.freeFieldDefinitionPermissions}
        />

        <ShowsPanelForProduction
          onFetch={res => setShowInProductionCount(res.pagination.total)}
          production={production}
        />
      </SectionPanel.Section>
    </TwoColumnLayout.LeftColumn>

    <TwoColumnLayout.RightColumn>
      <GeneralOptionsPanel
        data={viewModel.optionsPanel}
        links={[
          { text: RESX.Buttons.ListView, visible: true, href: viewModel.listUrl },
          { text: RESX.Buttons.btnCopy, visible: production.permissions.canModify, onClick: () => { setDisplayCopyModal(true); } },
          { text: RESX.Buttons.btnDelete, visible: production.permissions.canDelete, onClick: () => { setDisplayDeleteModal(true); } },
        ]}
      />

      <DeleteAndMoveProductions
        productionId={production.productionId}
        isOpen={displayDeleteModal}
        onClose={() => { setDisplayDeleteModal(false); }}
        afterDeleteRedirectUrl={viewModel.listUrl}
        associatedItemCount={showInProductionCount}
      />
      <ConfirmCopyProductionModal
        production={production}
        isOpen={displayCopyModal}
        onClose={() => { setDisplayCopyModal(false); }}
      />

      {isPanelVisible(viewModel.activityPanel) && <ProductionActivityPanel
        productionId={production.productionId}
        config={viewModel.activityPanel}
      />}
    </TwoColumnLayout.RightColumn>
  </TwoColumnLayout>
}

export default ProductionDetailApp;
